import { render } from "./MyProfile.vue?vue&type=template&id=3771f62c&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"

import "./MyProfile.vue?vue&type=style&index=0&id=3771f62c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3771f62c"]])

export default __exports__